export default __webpack_public_path__ + "static/media/Raleway-Regular.3927fa2a.ttf";